import React from 'react';

const ScenarioZones = ({ zones }) => {
    const zoneList = () =>
        zones.map(zone => (
            <tr>
                <td>{zone.zoneId}</td>
                <td className="character-wrap">{zone.zoneName}</td>
            </tr>
        ));

    return (
        <div className="test-instance-overview-pagination block pull-right device-list-container">
            <div className="test-instance-devices-list-pagination">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Zone Id</th>
                            <th>Zone Name</th>
                        </tr>
                    </thead>
                    <tbody>{zoneList()}</tbody>
                </table>
            </div>
        </div>
    );
};

export default ScenarioZones;
